import React from "react";
import PropTypes from "prop-types";
import {
  Typography,
  IconButton,
  DialogTitle as MuiDialogTitle,
} from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Close as CloseIcon } from "@material-ui/icons";

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      margin: 0,
      paddingBottom: 0,
    },
    text: {
      ...theme.typography.h4,
      color: "black",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: "black",
    },
  }),
);

const DialogTitle = props => {
  const classes = useStyles();
  const { children, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography className={classes.text}>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label='close'
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

export default DialogTitle;
